import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const VIDEO_URL = "/bg-video.mp4";
const APP_STORE_URL = "https://apps.apple.com/app/id1569461522";

const Home = () => {
  return (
    <main className="wf-root" data-testid="landing-root">
      <video
        className="wf-video"
        src={VIDEO_URL}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        data-testid="background-video"
      />
      <section className="wf-content">
        <h1 className="wf-title" data-testid="hero-title">
          <span className="wf-line">
            Watch<sup className="wf-tm">TM</sup>
          </span>
          <span className="wf-line">Faces</span>
        </h1>

        <p className="wf-tagline" data-testid="hero-tagline">
          <span className="wf-line">Time.</span>
          <span className="wf-line">
            <span className="wf-grad">Reimagined.</span>
          </span>
          <span className="wf-line">By You.</span>
        </p>

        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="wf-cta"
          data-testid="appstore-download-button"
        >
          <svg
            className="wf-apple"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
          >
            <path
              fill="currentColor"
              d="M16.365 1.43c0 1.14-.46 2.23-1.21 3.02-.79.85-2.07 1.51-3.12 1.43-.14-1.1.44-2.25 1.18-3.02.82-.86 2.22-1.5 3.15-1.43ZM20.5 17.3c-.56 1.3-.83 1.88-1.55 3.03-1 1.6-2.42 3.6-4.18 3.62-1.56.02-1.96-1.02-4.08-1.01-2.12.01-2.56 1.03-4.12 1.01-1.76-.02-3.1-1.82-4.1-3.42C-.17 16.7-.5 11.8 1.51 9.18c1.43-1.87 3.68-2.96 5.8-2.96 2.16 0 3.52 1.18 5.3 1.18 1.72 0 2.77-1.18 5.27-1.18 1.89 0 3.89 1.03 5.32 2.82-4.68 2.56-3.91 9.25-2.7 8.26Z"
            />
          </svg>
          <span className="wf-cta-label">Download on the App Store</span>
        </a>
      </section>
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
